<style lang="scss" scoped>
@use "assets/scss/default.scss";
</style>

<template>
  <div class="h-screen flex flex-col">
    <!-- Header pinned at the top -->
    <Header :nav-links="navLinks" class="flex-shrink-0 mt-3 ml-3 mr-3" />


    <!-- Navbar on the left with a fixed width and no growth -->
    <Navbar
      :navLinks="navLinks"
      class="flex-shrink-0 ml-3 absolute cconainter bottom-0 py-4"
    />

    <!-- Main flex container for navbar and main -->
    <div id="wrapper" class="flex flex-1 min-h-0 absolute p-4 overflow-auto">

      <!-- Main on the right, scrollable on overflow -->
      <main class="flex-1 min-h-0 h-full overflow-visible flex flex-col">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup>
const ui = {
  base: "h-full",
  padding: "",
  constrained: ""
};

const navLinks = [
  { url: "/management", name: "Administration", icon: "isax isax-element-4" },
  { url: "/management/accounts", name: "Comptes client", icon: "isax isax-buildings4" },
  { url: "/management/orders", name: "Commandes", icon: "isax isax-box" },
  { url: "/management/queue", name: "File d'attente", icon: "isax isax-timer-1" },
  { url: "/management/productions", name: "Productions", icon: "isax isax-printer" },
  { url: "/management/delays", name: "Délais", icon: "isax isax-clock" },
  { url: "/management/exports", name: "Exports hors UE", icon: "isax isax-export" },
  { url: "/management/printer-statements", name: "Relevés imprimeurs", icon: "isax isax-document-text" },
  { url: "/management/stocks", name: "Stocks", icon: "isax isax-box-1" },
  { url: "/management/config", name: "Configurations", icon: "isax isax-code-1" },
  { url: "/management/carriers", name: "Transporteurs", icon: "isax isax-truck" },
  { url: "/management/amazon-csv", name: "Import CSV Amazon", icon: "isax isax-import" },
];
</script>

<script>


export default {
  name: "ManagementLayout"
};
</script>
